export default __webpack_public_path__ + "static/media/7.64900f9f.webp";